<div class="undo-item">
    <mat-progress-spinner diameter="30" [value]="progressbarValue"></mat-progress-spinner>
    <div class="spinner-val"> {{curSec}} </div>
    <span class="message">{{undoItem.message}}</span>
    <button mat-button class="undo-btn" color="primary" (click)="undoActionClk()">
        <mat-icon>undo</mat-icon>
        Undo
    </button>
</div>